import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  NafathConfirmationCeckResponse,
  NafathDataResponse,
} from 'src/app/interfaces/nafath-verification.interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class NafathVerificationService {
  constructor(private http: HttpClient) {}

  getVerificationNumber(shortref: string) {
    const url = `${environment.BackEndURL}/api/merchant/MerchantIdentity/GetMerchantIdentityNafathData?shortref=${shortref}`;
    return this.http.get<NafathDataResponse>(url);
  }

  checkIsNafathVerificationSuccess(
    shortref: string,
    transId: string,
    Random: string
  ) {
    const url = `${environment.BackEndURL}/api/merchant/MerchantIdentity/VerifyMerchantIdentityStatus`;
    return this.http.post<NafathConfirmationCeckResponse>(url, {
      shortref,
      transId,
      Random,
    });
  }
}
